module.exports = __webpack_public_path__ + "img/0-97.9db7371b.jpg";